export class ResourceListDTO {
    
    id: string;

    name: string;

    description: string;

}
